import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    withStyles,
} from '@material-ui/core';
import { enabledField } from '../index';

const styles = (theme) => ({
    formControl: {
        width: '100%',
    },
});

const PresetGeneralSettings = (props) => {
    const { classes, translations, handleChange, values, orders, collies, setFieldValue, grades, printers } = props;

    const fieldNames = {
        PresetsEnabled: `PresetsEnabled`,
        AutoEnableRemoteAccess: `AutoEnableRemoteAccess`,
        AutoStartErasure: `AutoStartErasure`,
        AutoStartDiagnose: `AutoStartDiagnose`,
        OrderID: `OrderID`,
        TransportColliID: `TransportColliID`,
        ColliID: `ColliID`,
        PrinterID: `PrinterID`,
        GradeID: `GradeID`,
        ProcessingSessionEndMessage: `ProcessingSessionEndMessage`,
    };

    const fieldValues = {
        PresetsEnabled: values['PresetsEnabled'],
        AutoEnableRemoteAccess: values['AutoEnableRemoteAccess'],
        AutoStartErasure: values['AutoStartErasure'],
        AutoStartDiagnose: values['AutoStartDiagnose'],
        OrderID: values['OrderID'],
        TransportColliID: values['TransportColliID'],
        ColliID: values['ColliID'],
        PrinterID: values['PrinterID'],
        GradeID: values['GradeID'],
        ProcessingSessionEndMessage: values['ProcessingSessionEndMessage'],
    };

    return (
        <>
            <Typography align="center" variant={'h5'}>
                {translations['general_presets'] || 'General Presets'}
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['PresetsEnabled']}
                            checked={fieldValues['PresetsEnabled'] || false}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['enable_preset'] || 'Enable preset'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoEnableRemoteAccess']}
                            checked={fieldValues['AutoEnableRemoteAccess'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={translations['auto_enable_remote_access'] || 'Auto enable remote access'}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoStartErasure']}
                            checked={fieldValues['AutoStartErasure'] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['autostart_erasure'] || 'Autostart erasure'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoStartDiagnose']}
                            checked={fieldValues['AutoStartDiagnose'] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['autostart_diagnose'] || 'Autostart diagnose'}`}
                />
            </FormGroup>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['order_select'] || 'Please select order'}</InputLabel>
                <Select
                    name={fieldNames['OrderID']}
                    value={fieldValues['OrderID']}
                    label={translations['order'] || 'Order'}
                    margin={'dense'}
                    onChange={(event) => {
                        setFieldValue(fieldNames['TransportColliID'], '');
                        handleChange(event);
                        return event.stopPropagation();
                    }}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations['list_view'] || 'List view'}</em>
                    </MenuItem>
                    {(orders ? orders : []).map((option) => (
                        <MenuItem key={option.OrderID} value={option.OrderID}>
                            {option.Name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['transport_colli_text'] || 'Please select transport colli'}
                </InputLabel>
                <Select
                    name={fieldNames['TransportColliID']}
                    label={translations['transport_colli'] || 'Transport Colli'}
                    margin={'dense'}
                    value={fieldValues['TransportColliID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations['list_view'] || 'List view'}</em>
                    </MenuItem>
                    {(orders?.length > 0
                        ? orders.filter((order) =>
                              order.OrderID === fieldValues['OrderID'] ? fieldValues['OrderID'] : ''
                          )
                        : []
                    ).map((order) => {
                        return order.TransportCollies.map((option) => (
                            <MenuItem key={option.TransportColliID} value={option.TransportColliID}>
                                {option.Name}
                            </MenuItem>
                        ));
                    })}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['colli_text'] || 'Please select container'}</InputLabel>
                <Select
                    name={fieldNames['ColliID']}
                    label={translations['colli'] || 'Colli'}
                    margin={'dense'}
                    value={fieldValues['ColliID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations['list_view'] || 'List view'}</em>
                    </MenuItem>
                    {(collies ? collies : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['printers_text'] || 'Please select printer'}</InputLabel>
                <Select
                    name={fieldNames['PrinterID']}
                    label={translations['printers'] || 'Printers'}
                    margin={'dense'}
                    value={fieldValues['PrinterID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(printers ? printers : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['grade_text'] || 'Please select grade'}</InputLabel>
                <Select
                    name={fieldNames['GradeID']}
                    label={translations['grade'] || 'Grade'}
                    margin={'dense'}
                    defaultValue={''}
                    value={fieldValues['GradeID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(grades ? grades : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                name={fieldNames['ProcessingSessionEndMessage']}
                value={fieldValues['ProcessingSessionEndMessage'] || ''}
                onChange={handleChange}
                placeholder={translations['processing_session_end_message'] || 'Processing session end message'}
                label={translations['processing_session_end_message'] || 'Processing session end message'}
                margin={'dense'}
                fullWidth={true}
                multiline
                disabled={enabledField(values)}
            />
        </>
    );
};

export default withStyles(styles, { withTheme: true })(PresetGeneralSettings);
